/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Grand_TotalInputs */

const vi_order_grand_total = /** @type {(inputs: Order_Grand_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng cộng`)
};

/**

* @param {Order_Grand_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_grand_total = /** @type {((inputs?: Order_Grand_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Grand_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_grand_total(inputs)
});